var value = undefined;

export default {
    set: (v) => value = v,
    get: () => value,
    hasValue: () => !!value
};